import reRules from '@/plugins/rules'
import { h } from 'vue'

export const registerCustomerRefColumn = (dashboard) => {
  dashboard.registerCustomColumn({
    name: 'customer_ref',
    label: 'monolith.shared.customer_ref',
    component: (props) => {
      const customerRef = props.row?.customer_ref

      if (!customerRef) {
        return null
      }
      return h('span', customerRef)
    },
    options: {
      searchable: true,
      width: '40',
      validation: [reRules.minLength(3)],
    },
  })
}

export const registerCustomerRefColumnWithBankLabel = (dashboard) => {
  dashboard.registerColumn({
    type: 'text',
    name: 'customer_ref',
    label: 'request.bank',
    options: {
      searchable: true,
      width: '40',
      validation: [reRules.minLength(3)],
      sortable: false,
    },
  })
}
